import { Component, Input } from '@angular/core';
import { AppliedReportOptions, AppliedReportOptionAssociations } from 'app/core/models/report.model';

@Component({
  selector: 'app-report-applied-users-option',
  templateUrl: './report-applied-users-option.component.html'
})
export class ReportAppliedUsersOptionComponent {
  @Input() name = 'userIds';
  @Input() label = 'Users';
  @Input() options: AppliedReportOptions;
  @Input() optionAssociations: AppliedReportOptionAssociations;

  constructor() {}

  get fullNames() {
    const userIds = [this.options[this.name]].filter(Boolean).flat();

    if (userIds && userIds.length > 0) {
      return userIds.map(userId => {
        const optionAssociations = this.optionAssociations[this.name] || {};
        const user = optionAssociations[userId];
        return user && user.fullName;
      });
    } else {
      return ['ALL']
    }
  }

  get names() {
    return this.fullNames.join(', ');
  }
}
